var _path, _path2, _path3, _defs, _use, _clipPath, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _rect, _path4, _polygon6, _polygon7, _path5, _polygon8, _path6, _path7, _path8, _polygon9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    enableBackground: "new 0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.3558,
    y1: 583.0403,
    x2: 442.1384,
    y2: 658.1708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF9E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6C6359"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M273.9,576.6c-25.2,0.3-51.3,6.5-74.8,23.2c0,0-8,5.8-19.8,12.6c9.2-2.8,26.3-9.3,42.3-12.5 c54.2-10.8,92.8,17.4,109,27.7c0,0,43.6,29.1,106,6c-13.7-4.9-23.2-9.4-39.3-20.6l-3.9-2.2c0,0-54.4-33.3-115.1-34.1H273.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106137125517694579410000004939996377223097514_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.7526,
    y1: 627.9824,
    x2: 553.5264,
    y2: 627.9824
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6C6359"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AF9E8E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000106137125517694579410000004939996377223097514_)",
    d: "M436.8,633.5c65.1,21.6,116.8-9.9,116.8-9.9 l-61.1-8.8C475,622.7,452.6,630.8,436.8,633.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012444046592797568700000018341601466088168578_",
    gradientUnits: "userSpaceOnUse",
    x1: 943.1149,
    y1: 510.9937,
    x2: 1038.0433,
    y2: 510.9937
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF9E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6C6359"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000012444046592797568700000018341601466088168578_)",
    d: "M943.1,510.1v16c32.2-37.8,94.9,5,94.9,5 c-7.8-16-22-24.9-22-24.9c10.1-3.9,21.7-1.6,21.7-1.6c-19.4-10.3-35.7-13.9-49-13.9C957.9,490.8,943.1,510.1,943.1,510.1"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000126282045276660615360000016958461377306414245_",
    d: "M69.5,490.9c-3.9-8.7-2.8-19.1-1-26.5 c-24.3,31.2-28.3,66.6-26.7,92.4c1.4,22.8,10.7,39.7,10.7,39.7c9.7,19.7,36.1,34,62.3,35.6h9.8c0.4,0,0.8-0.1,1.2-0.1 c18.3-1.5,39-11.2,53.7-19.7c-26.1,7.9-35.3,8.1-35.3,8.1c-46.5,7.8-99.1-52.8-51.9-138.6c3.6-6.6,7.6-12.8,11.7-18.6 C86.3,468.8,69.5,490.9,69.5,490.9"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163053538862846143340000007743419508420871044_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.4365,
    y1: 547.6662,
    x2: 179.3712,
    y2: 547.6662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF9E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6C6359"
    }
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126282045276660615360000016958461377306414245_",
    overflow: "visible",
    fill: "url(#SVGID_00000163053538862846143340000007743419508420871044_)"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025435553141940015920000013612238802932178318_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000126282045276660615360000016958461377306414245_",
    overflow: "visible"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103948581798587602720000001758239063750383506_",
    gradientUnits: "userSpaceOnUse",
    x1: -122.413,
    y1: 812.1407,
    x2: 940.3696,
    y2: 362.9233
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4D7930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1223,
    style: {
      stopColor: "#698C35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3541,
    style: {
      stopColor: "#99B13E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5342,
    style: {
      stopColor: "#B9CB47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6395,
    style: {
      stopColor: "#C5D54B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6425,
    style: {
      stopColor: "#C2D24A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7083,
    style: {
      stopColor: "#85A13A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7577,
    style: {
      stopColor: "#618733"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7846,
    style: {
      stopColor: "#547E31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9441,
    style: {
      stopColor: "#4D7930"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000103948581798587602720000001758239063750383506_)",
    points: "710.4,380 710.4,645.6 283.6,585.6  283.1,455.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170266136829424526410000014174620740165394831_",
    gradientUnits: "userSpaceOnUse",
    x1: 1276.5775,
    y1: 523.8264,
    x2: 758.4906,
    y2: 514.4351
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05586592,
    style: {
      stopColor: "#4D7930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2154,
    style: {
      stopColor: "#547E31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#618733"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4235,
    style: {
      stopColor: "#85A13A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6029,
    style: {
      stopColor: "#C2D24A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    style: {
      stopColor: "#C5D54B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6726,
    style: {
      stopColor: "#BDCE48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7595,
    style: {
      stopColor: "#A8BC42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8614,
    style: {
      stopColor: "#86A13A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9738,
    style: {
      stopColor: "#588132"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D7930"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000170266136829424526410000014174620740165394831_)",
    points: "717.7,380.7 717.7,646.7 943.1,585.7  943.1,454.7 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035524713528047606760000017541021549783099563_",
    gradientUnits: "userSpaceOnUse",
    x1: 1332.2687,
    y1: 399.403,
    x2: 843.4509,
    y2: 390.5423
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05586592,
    style: {
      stopColor: "#4D7930"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2154,
    style: {
      stopColor: "#547E31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#618733"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4235,
    style: {
      stopColor: "#85A13A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6029,
    style: {
      stopColor: "#C2D24A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    style: {
      stopColor: "#C5D54B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6726,
    style: {
      stopColor: "#BDCE48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7595,
    style: {
      stopColor: "#A8BC42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8614,
    style: {
      stopColor: "#86A13A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9738,
    style: {
      stopColor: "#588132"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D7930"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000035524713528047606760000017541021549783099563_)",
    points: "943.1,447.7 1019.8,338.4 802.5,401.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013876880997649215650000006325935274133420180_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.4932,
    y1: 484.9225,
    x2: 173.3082,
    y2: 534.1627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF9E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2386,
    style: {
      stopColor: "#AA9A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4875,
    style: {
      stopColor: "#9D8E80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7409,
    style: {
      stopColor: "#887B6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#6D6359"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6C6359"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000013876880997649215650000006325935274133420180_)",
    points: "148,538.6 148,497.2 153.7,497.2  174,522.5 194.4,497.2 200.1,497.2 200.1,538.6 193.9,538.6 193.9,506.3 174,530.7 154.1,506.3 154.1,538.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082359158187834813400000006958016621285704097_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.1741,
    y1: 488.11,
    x2: 234.4133,
    y2: 529.1969
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF9E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3494,
    style: {
      stopColor: "#AC9B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5584,
    style: {
      stopColor: "#A39385"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7303,
    style: {
      stopColor: "#948679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8813,
    style: {
      stopColor: "#807469"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6C6359"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000082359158187834813400000006958016621285704097_)",
    points: "232.6,538.6 232.6,517.8 210,497.2  217.8,497.2 235.8,513.5 253.7,497.2 261.6,497.2 238.8,517.9 238.8,538.6 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 310.5,
    y: 497,
    fill: "#FFFFFF",
    width: 6.3,
    height: 41.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M339,538.6v-41.3h28.8c4.9,0,8.8,1,11.5,3c2.8,2,4.2,4.8,4.2,8.4c0,3-1.1,5.6-3.3,7.7 c-2.2,2.1-5.1,3.5-8.6,4l12.5,18.2h-6.9l-12.6-18.1h-19.5v18.1H339z M345.2,515.6h22.2c3.2,0,5.5-0.6,7.2-1.7c1.6-1.1,2.4-2.8,2.4-5 c0-2.2-0.8-3.9-2.4-5.1c-1.6-1.2-3.9-1.8-6.9-1.8h-22.5V515.6z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "402.3,538.6 402.3,497.2 441.8,497.2 441.8,502 408.6,502 408.6,514 428.6,514 428.6,518.8  408.6,518.8 408.6,533.8 443.8,533.8 443.8,538.6 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "460.6,538.6 460.6,497.2 466.8,497.2 466.8,533.8 499.6,533.8 499.6,538.6 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M507,538.6l24.6-41.3h5.2l24.8,41.3h-6.8l-6.8-11.2h-27.7l-6.6,11.2H507z M523.2,522.6h22.1l-11.1-18.3 L523.2,522.6z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "576.7,538.6 576.7,497.2 580,497.2 612.5,528.1 612.5,497.2 618.8,497.2 618.8,538.6 615.6,538.6  583,507.6 583,538.6 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M662.7,497.2c7.9,0,14.3,1.9,19.1,5.8c4.8,3.8,7.2,8.9,7.2,15c0,6.2-2.4,11.2-7.1,14.9 c-4.8,3.7-11.2,5.6-19.2,5.6h-21.5v-41.3H662.7z M662.7,502h-15.3v31.8h15.3c6.2,0,11.1-1.4,14.6-4.3c3.6-2.9,5.3-6.7,5.3-11.6 c0-4.8-1.8-8.6-5.4-11.5C673.6,503.4,668.8,502,662.7,502"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M745.9,538.6v-41.3h29.6c4.9,0,8.7,0.9,11.2,2.6c2.5,1.7,3.8,4.3,3.8,7.7c0,1.6-0.4,3.1-1.2,4.4 c-0.8,1.3-1.9,2.3-3.3,3.1c2.7,1.3,4.7,2.8,6,4.7c1.4,1.9,2.1,4,2.1,6.4c0,3.8-1.5,6.9-4.6,9.1c-3,2.2-7.2,3.4-12.4,3.4H745.9z  M752.1,513.5h24c2.6,0,4.6-0.5,6-1.5c1.4-1,2.1-2.4,2.1-4.2c0-1.9-0.7-3.4-2-4.4c-1.4-1-3.4-1.5-6.1-1.5h-24V513.5z M752.1,533.8 h26.2c2.9,0,5.1-0.7,6.7-2.1c1.6-1.4,2.5-3.3,2.5-5.7c0-2.4-0.8-4.2-2.5-5.6c-1.6-1.4-3.9-2.1-6.7-2.1h-26.2V533.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M836.1,539.7c-7.5,0-13.7-2-18.6-6.1c-4.9-4.1-7.4-9.3-7.4-15.5c0-6.3,2.5-11.5,7.4-15.6 c4.9-4.1,11.1-6.1,18.6-6.1c7.5,0,13.7,2.1,18.7,6.2c4.9,4.1,7.4,9.3,7.4,15.6c0,6.3-2.5,11.5-7.4,15.5 C849.9,537.6,843.6,539.7,836.1,539.7 M836.1,534.9c5.6,0,10.3-1.6,14-4.8c3.7-3.2,5.6-7.2,5.6-12.1c0-4.9-1.8-9-5.5-12.1 c-3.7-3.2-8.4-4.8-14-4.8c-5.6,0-10.3,1.6-14,4.8c-3.7,3.2-5.5,7.2-5.5,12.1c0,4.9,1.9,8.9,5.5,12.1 C825.8,533.3,830.5,534.9,836.1,534.9"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "874.3,538.6 894.8,517.8 874.6,497.2 882.3,497.2 898.7,513.8 915.2,497.2 922.7,497.2 902.5,517.5  923.2,538.6 915.2,538.6 898.5,521.5 881.7,538.6 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9c1d3448ba6dc775720702891ceb1f53.svg";
export { ForwardRef as ReactComponent };